import api from '../../domain/api';
import {
  GET_ADSREPORTS_STATED,
  GET_ADSREPORTS,
  GET_ADSREPORTS_ENDED,
  ADD_ADSREPORT_STATED,
  ADD_ADSREPORT,
  ADD_ADSREPORT_ENDED,
  EDIT_ADSREPORT_STATED,
  EDIT_ADSREPORT,
  EDIT_ADSREPORT_ENDED,
  GET_ADSREPORT_STATED,
  GET_ADSREPORT,
  GET_ADSREPORT_ENDED,
  GET_ALL_ADSREPORTS_STATED,
  GET_ALL_ADSREPORTS,
  GET_ALL_ADSREPORTS_ENDED,
  GET_FB_ADS_REPORTS_STARTED,
  GET_FB_ADS_REPORTS,
  GET_FB_ADS_REPORTS_ENDED,
} from '../types/adsreport_type';
import * as qs from 'qs';
import { handleError } from '../../shared/handleError';
import { setAlert } from './alert';

export const addAdsreport = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADD_ADSREPORT_STATED,
    });
    const { data } = await api.post(`/adsreports`, formData);
    dispatch({
      type: ADD_ADSREPORT,
      payload: data,
    });
    dispatch({
      type: ADD_ADSREPORT_ENDED,
    });
  } catch (error) {
    dispatch({
      type: ADD_ADSREPORT_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const uploadGoogleAdsreport =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_ADSREPORT_STATED,
      });
      const { data } = await api.post(
        `/adsreports/upload-google-ad-report`,
        formData
      );
      dispatch({
        type: ADD_ADSREPORT,
        payload: data,
      });
      dispatch({
        type: ADD_ADSREPORT_ENDED,
      });
    } catch (error) {
      dispatch({
        type: ADD_ADSREPORT_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const uploadFacebookAdsreports =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_ADSREPORT_STATED,
      });
      const { data } = await api.post(
        `/adsreports/upload-facebook-ad-report`,
        formData
      );
      dispatch({
        type: ADD_ADSREPORT,
        payload: data,
      });
      dispatch({
        type: ADD_ADSREPORT_ENDED,
      });
    } catch (error) {
      dispatch({
        type: ADD_ADSREPORT_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getAdsreports =
  ({ pageNumber = '' }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_ADSREPORTS_STATED,
      });
      const queryParams = qs.parse(window.location.search.replace('?', ''));
      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });

      const { data } = await api.get(
        `/adsreports?&pageNumber=${pageNumber}&${query}`
      );

      dispatch({
        type: GET_ADSREPORTS,
        payload: data,
      });
      dispatch({
        type: GET_ADSREPORTS_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_ADSREPORTS_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getFacebookAdsreports =
  ({ pageNumber = '' }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_FB_ADS_REPORTS_STARTED,
      });
      const queryParams = qs.parse(window.location.search.replace('?', ''));
      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });

      const { data } = await api.get(
        `/adsreports/facebook?&pageNumber=${pageNumber}&${query}`
      );

      dispatch({
        type: GET_FB_ADS_REPORTS,
        payload: data,
      });
      dispatch({
        type: GET_FB_ADS_REPORTS_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_FB_ADS_REPORTS_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getAdsreport = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ADSREPORT_STATED,
    });
    const { data } = await api.get(`/adsreports/${id}`);

    dispatch({
      type: GET_ADSREPORT,
      payload: data,
    });
    dispatch({
      type: GET_ADSREPORT_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_ADSREPORT_STATED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editAdsreport = (id, formData) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_ADSREPORT_STATED,
    });
    const { data } = await api.put(`/adsreports/${id}`, formData);
    dispatch({
      type: EDIT_ADSREPORT,
      payload: data,
    });
    dispatch({
      type: EDIT_ADSREPORT_ENDED,
    });
  } catch (error) {
    dispatch({
      type: EDIT_ADSREPORT_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteAdsreport = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/adsreports/${id}`);
    dispatch(setAlert('Adsreport Deleted Successfully', 'success'));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllAdsreports =
  ({ term, value }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_ALL_ADSREPORTS_STATED,
      });
      const { data } = await api.get(
        `/adsreports/all?term=${term}&value=${value}`
      );

      dispatch({
        type: GET_ALL_ADSREPORTS,
        payload: data,
      });
      dispatch({
        type: GET_ALL_ADSREPORTS_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_ADSREPORTS_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };

export const handleErrorLocal = () => async (dispatch) => {};
